import React, { useEffect, useState, Fragment } from 'react';
import { Row, Col, Button, message, Space, Typography, Spin, Form, Upload } from 'antd';
import DndListCard from 'Molecules/DndListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAdProducts } from '../../../../../ducks/actions';
import { removeAdProduct, bulkRemoveAdProducts, editAdProduct, addAdProduct, updateAdProductOrder } from '../../../../../ducks/services';
import ActionButton from 'Molecules/ActionButton';
// import Search from './components/Search';
import AllRoles from '../../../../../../../../routing/config/AllRoles';
import { allowed } from '../../../../../../../../routing/config/utils';
import { useTranslate } from 'Translate';
import { Popup } from 'Atoms/Popup';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { useForm } from 'react-hook-form';
import { InputField } from 'Atoms/FormElement';
import { dummyRequest, getFileName, uploadFileV2 } from 'Features/utility';
import FormGroup from 'Molecules/FormGroup';

const antIcon = <LoadingOutlined spin />;
const { Title } = Typography;

export default (props) => {
  const { id, activeTab } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const adProducts = useSelector((state) => state.loyaltyApp.adProducts);
  const adProductsOption = useSelector((state) => state.loyaltyApp.adProductsOption);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const allowedEdit = allowed([AllRoles.SYSTEM.REASON], 'write');
  const allowedDelete = allowed([AllRoles.SYSTEM.REASON], 'delete');
  const i18n = useTranslate();
  const { t } = i18n;
  const [visible, setVisible] = useState(false);
  const [load, setLoad] = useState(false);
  const { control, formState: { errors }, handleSubmit, setValue, clearErrors } = useForm();
  const [rec, setRecord] = useState();
  const [fileList, setFileList] = useState([]);
  const [fileId, setFileId] = useState();
  const [hasDirty, setHasDirty] = useState(false);
  const [data, setData] = useState([])

  const colName = [
    {
      title: t("LoyaltyApp.image"),
      dataIndex: 'image_url',
      key: 'image_url',
      width: 150,
      className: 'enable-click',
      render: (text) => <img width="100px" src={text} />
    },
    {
      title: t("General.code"),
      dataIndex: 'product_code',
      key: 'product_code',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Product.product_name"),
      dataIndex: 'product_name',
      key: 'product_name',
      className: 'enable-click',
      sorter: true
    },
    // {
    //   title: t("General.status"),
    //   dataIndex: 'status',
    //   key: 'status',
    //   sorter: true,
    //   render: (text, record) =>
    //     <div className='flex align-items-center'>
    //       <span className={text === "Active" ? "c-success" : "c-danger"}>
    //         {t(`General.${text?.toLowerCase()}`)}
    //       </span>
    //       {
    //         allowedEdit &&
    //         <Button type="link" onClick={() => onAction(record.id, text)}>
    //           {text === "Active" ? `(${t("General.deactivate")})` : `(${t("General.activate")})`}
    //         </Button>
    //       }
    //     </div>
    // },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) =>
        <ActionButton
          title="ad_product"
          btnAction1={() => {
            setVisible(true);
            setRecord(record);
            setValue('product', { label: `${record?.product_code} ${record?.product_name}`, value: record?.product_id });
            if (record?.image_url) {
              setFileList([
                {
                  uid: '-1',
                  name: getFileName(record?.image_url),
                  status: 'done',
                  url: record?.image_url
                }
              ])
            }else {
              setFileList();
              setFileId();
            }
          }}
          recordId={record.id}
          onRemove={allowedDelete && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ]

  const formFields = [
    {
      name: 'product',
      label: t("Product.product"),
      placeholder: t("General.please_select"),
      req: true,
      type: 'select',
      reqmessage: t("General.required"),
      twocol: false,
      options: adProductsOption?.products?.map((x) => ({ label: `${x.code} ${x.name}`, value: x.id })),
      colWidth: '1 0 100%',
      class: 'default-select',
      static: !allowedEdit
    },
  ];

  const addNew = () => { 
    setVisible(true);
    setRecord();
    setFileId();
    setFileList([]);
    setValue('product', '');
  }

  const btnList = [
    {
      title: t("Product.confirm_reorder_list"),
      text: t("General.update_listing"),
      classes: 'b-success attendance-success',
      btnHidden: !hasDirty,
      action: () => onUpdateList()
    },
    {
      title: t("LoyaltyApp.confirm_remove_selected_ad_products"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("LoyaltyApp.new_ad_product")}`,
      action: () => addNew(),
    },
  ];

  useEffect(() => {
      if (activeTab === "2")
      dispatch(getAdProducts(1, limit, '', '', props.setLoading, id));
    }, [activeTab]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onRemove = async (adProductId) => {
    props.setLoading(true);

    const payload = {
      ad_product_id: adProductId,
      status_event: 'remove'
    }

    await removeAdProduct(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("LoyaltyApp.ad_product_remove_success"));
        setTimeout(() => dispatch(getAdProducts(page, limit, '', '', props.setLoading, id)), 500);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      ad_products: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveAdProducts(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("LoyaltyApp.ad_products_remove_success"));
        setPage(1);
        setTimeout(() => dispatch(getAdProducts(1, limit, '', '', props.setLoading, id)), 500);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getAdProducts(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, props.setLoading, id));
    } else {
      dispatch(getAdProducts(pagination.current, pagination.pageSize, '', '', props.setLoading, id));
    }
  }

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click")){
          setVisible(true);
          setRecord(record);
          setValue('product', { label: `${record?.product_code} ${record?.product_name}`, value: record?.product_id });
          record?.image_url ? setFileList([
            {
              uid: '-1',
              name: getFileName(record?.image_url),
              status: 'done',
              url: record?.image_url
            }
          ]) : setFileList([]);
        }
      },
    };
  };

  const handleUpload = async (e) => {
    setLoad(true);
    try {
      let file = await uploadFileV2(e.file.originFileObj);
      setLoad(false);
      setFileId(file?.id);
      setFileList([{ uid: '-1', name: file?.filename, status: 'done', url: file?.url }]);
    } catch (error) {
      message.error(`${t("General.error_during_upload")} ${error}`);
      props.setLoading(false);
    }
  };

  const onFinish = async (val) => {
    setLoad(true);

    const payload = {
      ad_id: id,
      blob_id: fileId,
      product_id: val?.product?.value,
      ad_product_id: rec?.id
    }

    rec?.id ?
    await editAdProduct(payload).then(res => {
      setLoad(false);
      if(res.data.code === 200) {
        message.success(t("LoyaltyApp.ad_product_update_success"));
        setVisible(false);
        setRecord();
        setFileId();
        setValue('product', '');
        setTimeout(() => dispatch(getAdProducts(1, limit, '', '', props.setLoading, id)), 500);
      }else {
        message.error(res.data.message);
      }
    }).catch(e =>{
      setLoad(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    }) :
    await addAdProduct(payload).then(res => {
      setLoad(false);
      if(res.data.code === 200) {
        message.success(t("LoyaltyApp.ad_product_add_success"));
        setVisible(false);
        setFileId();
        setValue('product', '');
        setTimeout(() => dispatch(getAdProducts(1, limit, '', '', props.setLoading, id)), 500);
      }else {
        message.error(res.data.message);
      }
    }).catch(e =>{
      setLoad(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    });
  };

  const onAction = async (recordId, status) => {
    props.setLoading(true);

    const payload = {
      ad_product_id: recordId,
      status_event: status === 'Active' ? 'deactivate' : 'activate'
    }

    await removeAdProduct(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Product.menu_category_status_update_success"));
        callApi();
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  useEffect(() => {
    if(adProducts) {
      setData(adProducts?.list);
    } 
  }, [adProducts]);

  const onUpdateList = async () => {
    props.setLoading(true);

    const payload = {
      ad_id: id,
      ad_products: JSON.stringify(data?.map((d, i) => ({ id: d.id, position: i + 1 })))
    }
    await updateAdProductOrder(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Product.menu_types_order_update_success"));
        setHasDirty(false);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const popup = {
    closable: false,
    visibility: visible,
    content: <Spin indicator={antIcon} size="large" spinning={load}>
      <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
        <Space direction='vertical' size={15} className='w-100'>
          <Title level={4} className='m-0'>
            {rec?.id ? t("LoyaltyApp.edit_ad_product") : t("LoyaltyApp.add_ad_product")}
          </Title>
          <InputField
            fieldname='id'
            label=''
            class='d-none'
            initValue={''}
            control={control}
          />
          <div className='text-center'>
            <Upload
              disabled={!allowedEdit}
              listType="picture-card"
              className="avatar-uploader larger"
              showUploadList={false}
              accept="image/*"
              maxCount={1}
              fileList={fileList}
              customRequest={dummyRequest}
              onChange={(e) => handleUpload(e)}
            >
              <Space size={4}>
                {fileList?.length > 0 ? (
                  <img
                    src={fileList[0].url}
                    alt="avatar"
                    style={{
                      width: '100%',
                    }}
                  />
                ) :
                  <div>
                    <PlusOutlined />
                    <div
                      style={{
                        marginTop: 8,
                      }}
                    >
                      {t("General.upload")}
                    </div>
                  </div>
                }
              </Space>
            </Upload>
          </div>
          <Row gutter={[10, 10]}>
            {formFields?.map((x, idx) => (
              <Fragment key={idx}>
                <FormGroup item={x} control={control} errors={errors} />
              </Fragment>
            ))}
          </Row>
          <Row gutter={10} justify={'center'}>
            <Col span={12}><Button size='large' danger type="primary" className='w-100' onClick={() => {
              setVisible(false);
              clearErrors();
            }}>{t("General.cancel")}</Button></Col>
            {
              allowedEdit &&
              <Col span={12}><Button size='large' type="primary" className='green-btn w-100' htmlType='submit'>{t("General.confirm")}</Button></Col>
            }
          </Row>
        </Space>
      </Form>
    </Spin>,
    width: 536,
    onCancel: () => {
      setVisible(false);
      clearErrors();
    },
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={""} btnList={allowedEdit ? btnList : null} btnHidden={selectedRowKeys.length <= 0} />
        </Col>
        <Col span={24} className="clickRow">
          {/* <ListCard
            onRow={onClickRow}
            listClass="nopad"
            ListData={adProducts?.list?.map(x => ({ ...x, key: x.id }))}
            onChange={onTableChange}
            ListCol={colName}
            rowSelection={rowSelection}
            pagination={{
              total: adProducts?.total_count,
              current: page,
              pageSize: limit
            }}
          /> */}

          <DndListCard
            setHasDirty={setHasDirty}
            setDataList={setData}
            list={data}
            classes="nopad"
            ListData={data?.map(x => ({ ...x, key: x.id }))}
            onChange={onTableChange}
            ListCol={colName}
            rowSelection={rowSelection}
            pagination={{
              total: adProducts?.total_count,
              current: page,
              pageSize: limit
            }}
          />
        </Col>
      </Row>
      <Popup {...popup} />
    </>
  )
}